import React from 'react';
import styled from 'styled-components';
import { dropShadow, border3D } from '../../constants';

const Button = styled.button`
    ${dropShadow}
    ${border3D}
    height: 100%;
    width: 100%;
    ${props => `
        background: ${props.background};
        border-color: ${props.background};
        color: ${props.color};

        :hover:enabled{
          border-color: ${props.hover};
        }
        :focus {
          border-color: ${props.hover};
        }
    `}
`;

export default function RaisedButton(props) {
  const {
    onClick, children,
  } = props;

  return (
    <Button
      onClick={() => onClick}
      {...props}
    >
      {children}
    </Button>

  );
}
